'use strict';

wbApp.factory('activityScheduleSvc', ['$resource', '$q', '$translate', 'repositorySvc', 'semesterSvc', 'notificationSvc',
function ($resource, $q, $translate, repositorySvc, semesterSvc, notificationSvc) {
    var ActivitySchedules = $resource('/Api/ActivitySchedules/:id', {}, {
        'getAllBySemesterAndActivityID': { method: 'GET', isArray: true, url: '/Api/ActivitySchedules/GetAllBySemesterAndActivityID' },
        'save': { method: 'POST', url: '/Api/ActivitySchedules/Save', isArray: true },
    });

    var bySemesterAndActivity;
    var lastSemesterID;
    var lastActivityID;

    function getAllBySemesterAndActivityIDAsync(semesterID, activityID, reload) {
        if (!bySemesterAndActivity || lastSemesterID !== semesterID || lastActivityID !== activityID || reload) {
            bySemesterAndActivity = repositorySvc.customGet('getAllBySemesterAndActivityID', ActivitySchedules, {
                semesterID: semesterID,
                activityID: activityID
            });
            lastSemesterID = semesterID;
            lastActivityID = activityID;
        }

        return bySemesterAndActivity;
    }

    function getWeeksAsync(semesterID, activityID, reload) {
        var result = [];
        var deferred = $q.defer();

        $q.all([
            semesterSvc.getAsync(semesterID),
            getAllBySemesterAndActivityIDAsync(semesterID, activityID, reload).$promise
        ]).then(function (data) {
            var semester = data[0];
            var schedules = data[1];
            var scheduleModel = new webooker_acivity_models.Schedule(semester.startDate, semester.endDate, schedules);
            result.push.apply(result, scheduleModel.weeks);
            deferred.resolve(result);
        });

        result.$promise = deferred.promise;
        return result;
    }

    function getToBeSendToServer(selectedWeeks, semesterId, activityId) {
        var toBeSendToServer = [];
        for (var w = 0; w < selectedWeeks.length; w++) {
            var week = selectedWeeks[w];

            for (var s = 0; s < week.schedules.length; s++) {
                var schedule = week.schedules[s];

                schedule.semesterID = semesterId;
                schedule.activityID = activityId;
                toBeSendToServer.push(schedule);
                
            }
        }

        return toBeSendToServer;
    }

    function saveAsync(weeks, semesterId, activityId) {

        var toBeSendToServer = getToBeSendToServer(weeks, semesterId, activityId);

        var result = [];
        var deferred = $q.defer();

        var res = ActivitySchedules.save({
            semesterID: semesterId,
            activityID: activityId,
            model: toBeSendToServer
        });

        $q.all([            
            semesterSvc.getAsync(semesterId),
            res.$promise
        ]).then(function (data) {
            var semester = data[0];
            var schedules = data[1];
            var scheduleModel = new webooker_acivity_models.Schedule(semester.startDate, semester.endDate, schedules);
            result.push.apply(result, scheduleModel.weeks);

            bySemesterAndActivity = result;
            lastSemesterID = semesterId;
            lastActivityID = activityId;

            deferred.resolve(result);
            notificationSvc.notifyInfo($translate.instant('TXT_ALERT_TITLE_ACTIVITY_SCHEDULE_SAVED'));
        }, function (errorResult) {
            if (errorResult.status === 403) {
                notificationSvc.fatalNotify($translate.instant('TXT_ALERT_TITLE_FORBIDEN'));
            } else {
                notificationSvc.notifyError(
                    $translate.instant('TXT_ALERT_TITLE_ACTIVIT_SCHEDULE_SAVE_ERROR'),
                    notificationSvc.translateError(errorResult.data));
            }
            deferred.reject(errorResult);
        });

        return deferred.promise;
    }

    return {
        getWeeksAsync: getWeeksAsync,
        saveAsync: saveAsync
    }
}]);
